(() => {
  // These checkout controls intentionally remain on the current page.
  function showLoading(button, event) {
    if (button.disabled || button.getAttribute('aria-disabled') === 'true') return;
    if (button.classList.contains('bonner-express-guard') && event.detail > 0) {
      const rect = button.getBoundingClientRect();
      button.style.setProperty('--bonner-spinner-x', `${Math.max(16, Math.min(rect.width - 16, event.clientX - rect.left))}px`);
      button.style.setProperty('--bonner-spinner-y', `${Math.max(16, Math.min(rect.height - 16, event.clientY - rect.top))}px`);
    }
    button.classList.add('bonner-checkout-loading');
    button.setAttribute('aria-busy', 'true');
    button.setAttribute('aria-disabled', 'true');
    const status = document.createElement('span');
    status.className = 'visually-hidden';
    status.setAttribute('role', 'status');
    status.textContent = 'Loading';
    button.append(status);
  }

  // Delegation keeps working when Shopify replaces cart sections after updates.
  window.addEventListener('click', (event) => {
    const button = event.target instanceof Element && event.target.closest('[data-bonner-checkout]');
    if (!button) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showLoading(button, event);
  }, true);

  window.addEventListener('submit', (event) => {
    if (!event.submitter?.matches('[data-bonner-checkout]')) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    showLoading(event.submitter, event);
  }, true);
})();
